import HttpService from '../../../common/http/HttpService';
import Endpoint from '../const/Endpoint';
import makeRule from './RuleFactory';
import makeTicket from './TicketFactory';

async function getFrequencies() {
  const { data } = await HttpService.post(Endpoint.GET_FREQUENCIES);
  return data;
}

async function getFrequency(type, frequencyId) {
  const { data } = await HttpService.post(Endpoint.GET_FREQUENCY, { type, frequencyId });
  return data;
}

async function getList(systemIds) {
  const rules = await HttpService.post(Endpoint.LIST, { systemIds });
  const ruleData = rules.data.map((rule) => makeRule(rule));
  await Promise.all(ruleData.map(async (rule) => {
    const newRule = rule;
    newRule.frequency = await getFrequency(rule.type, rule.frequency);
  }));
  return ruleData;
}

async function save(systemId, config, type) {
  const data = {
    ...config,
    systemId,
    date: config.date.toISOString(),
    frequency: config.frequency.id,
    type,
  };
  return HttpService.post(Endpoint.SAVE, data);
}

async function remove(systemId, config) {
  const data = { ...config, systemId };
  return HttpService.post(Endpoint.REMOVE, data);
}

async function getRuleByTicketId(ticketId) {
  const { data } = await HttpService.post(Endpoint.GET_BY_TICKET_ID, { ticketId });
  return data;
}

async function getNextOccurrences(date, endDate, frequency, type, amount = 4) {
  const config = {
    date: date.toISOString(),
    endDate: endDate === null ? null : endDate.toISOString(),
    frequency,
    type,
    amount,
  };
  const { data } = await HttpService.post(Endpoint.GET_NEXT_OCCURRENCES, config);
  return data;
}

async function getOccurencesRange(systemIds, filters) {
  const { data } = await HttpService.post(Endpoint.GET_OCCURRENCES_RANGE, { systemIds, filters });
  return data;
}

async function getTicketList(ruleId) {
  const tickets = await HttpService.post(Endpoint.LIST_TICKETS, { ruleId });
  return tickets.data.map((ticket) => makeTicket(ticket));
}

function containsSearchTerm(rule, term) {
  if (term === undefined || term === '') {
    return true;
  }
  return rule.title.toLowerCase().includes(term.toLowerCase())
    || rule.description?.toLowerCase().includes(term.toLowerCase());
}

function filterRuleByType(rule, type) {
  return type === null ? true : rule.type === type;
}

const RuleService = {
  getList,
  getTicketList,
  save,
  remove,
  getNextOccurrences,
  getOccurencesRange,
  containsSearchTerm,
  getFrequencies,
  filterRuleByType,
  getRuleByTicketId,
};

export default RuleService;
